import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEBusinessLogic } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BLParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BLParameter';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { EnumDTPType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointBusinessLogicShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointBusinessLogicShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_BusinessLogic.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(businessShape: NodeShape, businessLogic: BEBusinessLogic, isFromJSON: boolean) {
    if (businessLogic) {
      MDExtendService.setElementListSequence(businessLogic.parameters, false);
    }
    this.setBaseMD(businessShape, this.createModel(businessLogic, !businessShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_BUSINESSLOGIC;
  }

  get businessLogic(): BEBusinessLogic {
    return this.element() as BEBusinessLogic;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加参数
      case 'shape:addParameter':
        element = this.addParameter();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION || linkType === MDAConstant.Link.ADD_GENERALIZATION ||
        linkType === MDAConstant.Link.ADD_ASSOCIATION || linkType === MDAConstant.Link.ADD_DEPENDENCY || linkType === MDAConstant.Link.ADD_IMPLEMENT) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof BLParameter) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addParameter(): BLParameter {
    const parameter = MDRepository.createBLParameter(this.businessLogic);
    MDExtendService.setElementListSequence(this.businessLogic.parameters, true);
    this.model().compartments[0].push(parameter);
    return parameter;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.businessLogic.parameters.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.businessLogic.parameters.splice(this.businessLogic.parameters.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(businessLogic: BEBusinessLogic, isCollapse = false): ShapeModel {
    const model = new ShapeModel(businessLogic, isCollapse);
    model.addCompartment(businessLogic.parameters.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointBusinessLogicShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEBusinessLogic();
    newElement.copyFrom(this.businessLogic, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.businessLogics.push(newElement);
    }

    this.businessLogic.parameters.forEach(item => {
      const parameter = new BLParameter();
      parameter.copyFrom(item, false);
      MDExtendService.setCreateInfo(parameter);
      parameter.businessLogic_ID = newElement.id;
      newElement.parameters.push(parameter);
      elements.push(parameter);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): BLParameter | null {
    let newElement: BLParameter | null = null;
    if (element instanceof BLParameter) {
      newElement = new BLParameter();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.businessLogic_ID = this.businessLogic.id;
      this.businessLogic.parameters.push(newElement);
      this.model().compartments[0].push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 商业逻辑
   *    - 名称必须以大写字母BL开头
   *    - 分布式协议类型目前只支持TCC
   * 2. 返回值
   *    - 数据类型为引用时，必须选择引用数据类型
   *    - 设置返回分页的时候，必须设置返回值是集合
   * 3. 参数
   *    - 参数必须填写名称
   *    - 参数必须填写显示名称
   *    - 不能存在同名参数
   *    - 参数数据类型为引用时，必须选择引用数据类型
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.businessLogic.designId;
    MDValidation.validateBaseElement(this.businessLogic, this.businessLogic.designId, true, errors);
    if (this.businessLogic.enableDistributeTransaction && this.businessLogic.dTPType !== EnumDTPType.TCC) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `商业逻辑 [${this.businessLogic.displayName}] 分布式协议类型目前仅支持TCC`));
    }
    if (this.businessLogic.returnDataType === EnumDataType.Reference && !ValidateHelper.IsNotNullOrEmpty(this.businessLogic.returnReferenceType)) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `商业逻辑 [${this.businessLogic.displayName}] 返回值数据类型为引用时，必须选择引用数据类型`));
    }
    if (this.businessLogic.returnIsPaged && !this.businessLogic.returnIsCollection) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `商业逻辑 [${this.businessLogic.displayName}] 设置返回分页的时候，必须设置返回值是集合`));
    }
    this.businessLogic.parameters.forEach((parameter) => {
      MDValidation.validateBaseElement(parameter, containerDesignId, false, errors);
      if (!ValidateHelper.validateFirstIsLower(parameter.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `商业逻辑 [${this.businessLogic.displayName}] 的参数名称 [${parameter.name}] 必须以小写字母开头`));
      }
      if ((parameter.dataType === EnumDataType.Reference || parameter.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(parameter.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `商业逻辑 [${this.businessLogic.displayName}] 的参数 [${parameter.displayName}] 必须选择引用数据类型`));
      }
      if (this.businessLogic.parameters.find(item => parameter.designId !== item.designId && parameter.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `商业逻辑 [${this.businessLogic.displayName}] 不能存在同名参数 [${parameter.displayName}]`));
      }
    });
    return errors;
  }
}
